import { BaseInputTemplate } from './BaseInputTemplate';
import { FieldTemplate } from './FieldTemplate';
import { ObjectFieldTemplate } from './ObjectFieldTemplate';

export const templates = { FieldTemplate, BaseInputTemplate, ObjectFieldTemplate };
